import React from 'react';
import { MdClose } from 'react-icons/md';
import styles from './BankDetailsView.module.scss';

const BankDetailsView = ({ item, onClose }) => {
  if (!item) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2>बैंक खाता विवरण फारम</h2>
          <button onClick={onClose} className={styles.closeButton}>
            ×
          </button>
        </div>

        <div className={styles.form}>
          <div className={styles.tableContainer}>
            <table className={styles.formTable}>
              <tbody>
                <tr>
                  <th colSpan="4" className={styles.centerHeader}>
                    मध्यपश्चिम विश्वविद्यालय
                  </th>
                </tr>
                <tr>
                  <td>कार्यालयको नाम.-</td>
                  <td colSpan="3">
                    <div className={styles.displayValue}>
                      {item.office_name || 'N/A'}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>लेखा प्रमुखको नाम</td>
                  <td colSpan="3">
                    <div className={styles.displayValue}>
                      {item.account_head_name || 'N/A'}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>लेखा प्रमुखको <b>official Mail ID</b></td>
                  <td colSpan="3">
                    <div className={styles.displayValue}>
                      {item.official_email || 'N/A'}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th colSpan="4" className={styles.centerHeader}>
                    कार्यालयको नाममा सञ्चालित सम्पूर्ण बैक खाताको विवरण
                  </th>
                </tr>
                <tr>
                                          <th>क्र.सं.</th>
                        <th>बैंक नाम</th>
                  <th>खाताको प्रकार</th>
                  <th>खाता नं.</th>
                </tr>
                {item.bank_accounts && item.bank_accounts.map((account, index) => (
                  <tr key={account.id || index}>
                    <td>{index + 1}</td>
                    <td>
                      <div className={styles.displayValue}>
                        {account.bank_name || 'N/A'}
                      </div>
                    </td>
                    <td>
                      <div className={styles.displayValue}>
                        {account.account_type || 'N/A'}
                      </div>
                    </td>
                    <td>
                      <div className={styles.displayValue}>
                        {account.account_number || 'N/A'}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className={styles.note}>
            <p><b>नोट:-</b> सम्पूर्ण नमस्कार, माथि उल्लेखित विवरण अनिवार्यरुपमा भर्नुहोस् जानकारी गराइन्छ ।</p>
          </div>

          <div className={styles.formActions}>
            <button
              type="button"
              onClick={onClose}
              className={styles.closeButton}
            >
              बन्द गर्नुहोस्
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankDetailsView;
